
import axios from 'axios'
import { reduceParams } from 'utils/helpers'
import { ThunkAction } from 'store/types'
import { DEPARTMENT_ID } from '../../constants'
import * as actions from './actions'
import { finishLoading, startLoading } from '../loading/actions'
import { handleErrorMessageAlert } from 'components/UI/Alert'

export const fetchMostActiveCpt4 = (size?: number, page?: number, text?: string): ThunkAction => {
    return async (dispatch) => {
  
      if (!size) {
          size = 300
      }

      dispatch(startLoading())
      dispatch(actions.getMostActiveCpt4Request())

      dispatch(startLoading())
      try {
        let resp
        if (text) {
          resp = await axios.get(`/cpt4MostActive?&keyWord=${text}&size=${size}&page=${page}`)
        } else {
          resp = await axios.get(`/cpt4MostActive?&size=${size}&page=${page}`)
        }
        console.log(resp)
        dispatch(actions.getMostActiveCpt4Success(resp.data))
      } catch (err) {
        dispatch(actions.getMostActiveCpt4Fail(err))
      }

      dispatch(finishLoading())
    }
  }
  
  export const createMostActiveCpt4 = (cpt4: { code: string; description: string; }): ThunkAction => {
    return async dispatch => {
      dispatch(actions.createMostActiveCpt4Request())
      
      dispatch(startLoading())
      try {
        const resp = await axios.post('/cpt4', {
            ...reduceParams(cpt4)
        })
        if (resp.status === 200) {
          dispatch(actions.createMostActiveCpt4Success(resp.data))
        } else {
          if (resp && resp.data && resp.data.errorMessage) {
            handleErrorMessageAlert(resp.data.errorMessage)
            dispatch(actions.createMostActiveCpt4Fail(resp.data.errorMessage))
          }
        }
      } catch (err) {
          if (err.response && err.response.data && err.response.data.errorMessage) {
              handleErrorMessageAlert(
                err.response && err.response.data && err.response.data.errorMessage
              )
          }
          dispatch(actions.createMostActiveCpt4Fail(err))
      }
      
      dispatch(finishLoading())
    }
  }
  
  export const updateMostActiveCpt4 = (cpt4: { id: number, code: string; description: string; }): ThunkAction => {
    return async dispatch => {
      dispatch(actions.updateMostActiveCpt4Request())
      
      dispatch(startLoading())
      console.log(cpt4)
      try {
        const resp = await axios.put(`/cpt4/${cpt4.id}`, {
            ...reduceParams(cpt4)
        })
        if (resp.status === 200) {
          dispatch(actions.updateMostActiveCpt4Success(resp.data))
        } else {
          if (resp && resp.data && resp.data.errorMessage) {
            handleErrorMessageAlert(resp.data.errorMessage)
            dispatch(actions.updateMostActiveCpt4Fail(resp.data.errorMessage))
          }
        }
      } catch (err) {
          if (err.response && err.response.data && err.response.data.errorMessage) {
              handleErrorMessageAlert(
                err.response && err.response.data && err.response.data.errorMessage
              )
          }
        dispatch(actions.updateMostActiveCpt4Fail(err))
      }
      
      dispatch(finishLoading())
    }
  }
  
  export const deleteMostActiveCpt4 = (cpt4Id: number): ThunkAction => {
    return async dispatch => {
      dispatch(actions.deleteMostActiveCpt4Request())
      
      dispatch(startLoading())
      try {
        const resp = await axios.delete(`/cpt4/${cpt4Id}`)
        if (resp.status === 200) {
          dispatch(actions.deleteMostActiveCpt4Success(resp.data))
        } else {
          if (resp && resp.data && resp.data.errorMessage) {
            handleErrorMessageAlert(resp.data.errorMessage)
            dispatch(actions.deleteMostActiveCpt4Fail(resp.data.errorMessage))
          }
        }
      } catch (err) {
          if (err.response && err.response.data && err.response.data.errorMessage) {
              handleErrorMessageAlert(
                err.response && err.response.data && err.response.data.errorMessage
              )
          }
        dispatch(actions.deleteMostActiveCpt4Fail(err))
      }
      
      dispatch(finishLoading())
    }
  }